const permissions = {
  listServiceClass: 'UP017',
  addServiceClass: 'UP018',
  editServiceClass: 'UP019',
  deleteServiceClass: 'UP020'
};

export default permissions;
